import React, { useEffect, useState } from 'react';

import { text } from '../../text';
import { utils } from '../../utils';
import { items } from '../../items';
import { custom } from '../../custom';
import { svg } from '../../assets/svg';
import { formatMoney, theme } from '../../constants';
import { components } from '../../components';
import { hooks, RootState } from '../../hooks';
import { createOrder } from '../../services/orderService';
import Main_logo_green from '../../assets/images/Main_Logo_green.png';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Select,
  MenuItem,
  InputLabel,
} from '@mui/material';
import { keyframes } from '@emotion/react';
import Paper from '@mui/material/Paper';
import ConfettiExplosion from 'react-confetti-explosion';
import { actions } from '../../store/actions';
import { useLocation } from 'react-router-dom';
import FloatingWhatsAppButton from '../../components/FloatingWhatsAppButton';
import toast from 'react-hot-toast';

export const Order: React.FC = () => {
  const dispatch = hooks.useAppDispatch();
  const navigate = hooks.useAppNavigate();
  const [open, setOpen] = useState(false);
  const [isExploding, setIsExploding] = React.useState(false);
  const [loading, setIsLoading] = React.useState(false);
  const isSignedIn = Boolean(sessionStorage.getItem('authToken')); // Or use a state from Redux
  const [deliveryMethod, setDeliveryMethod] = useState('pickup_from_shop');
  const [message, setMessage] = useState('');
  const [orderId, setOrderId] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleOrderSuccess = () => {
    // Show modal when order is successful
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const { subtotal, discount, list, total, discountAmount, totalWeight } =
    hooks.useAppSelector((state: RootState) => state.cartSlice);
  // console.log(list);
  useEffect(() => {
    // if (!isSignedIn) {
    //   navigate('/SignIn');
    // }
    window.scrollTo(0, 0);
  }, []);

  //  console.log(list);

  const OrderSuccessModal: React.FC<{
    open: boolean;
    onClose: () => void;
    message: string;
    orderId: number;
  }> = ({ open, onClose, message, orderId }) => {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby='success-dialog-title'
        maxWidth='xs' // Make the modal smaller
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '20px', // Rounded corners
            padding: '20px', // Padding for better spacing
            textAlign: 'center', // Center content
          },
        }}
      >
        <img
          src={Main_logo_green}
          alt='Logo'
          style={{
            width: '120px',
            height: '72px',
            marginBottom: '16px', // Space below the image
            cursor: 'pointer',
          }}
          onClick={() => navigate('/Home')}
        />
        <DialogTitle id='success-dialog-title'>Order Successful!</DialogTitle>
        <DialogTitle id='success-dialog-title'>{message}</DialogTitle>

        <DialogContent>
          <div
            style={{
              position: 'relative',
              overflow: 'hidden',
              height: '10px',
              width: '100%',
            }}
          >
            {isExploding && <ConfettiExplosion />}
          </div>
          <div
            style={{
              background: theme.colors.mainColor,
              color: theme.colors.white,
              padding: '10px 20px',
              borderRadius: '20px',
              cursor: 'pointer',
            }}
            onClick={() => {
              navigate('/OrderHistory', {
                state: {
                  orderId: orderId,
                },
              });
            }}
          >
            View detail
          </div>
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <components.Button
              title='Close'
              style={{
                color: theme.colors.mainColor,
                backgroundColor: theme.colors.white,
                border: `1px solid ${theme.colors.mainColor}`,
                // padding: '8px 10px',
                borderRadius: '20px',
              }}
              colorScheme='light'
              onClick={onClose}
            />
          </div>
        </DialogContent>
      </Dialog>
    );
  };

  const renderHeader = (): JSX.Element | null => {
    return (
      <components.Header
        // title='Order'
        // burger={true}
        basket={true}
        line={true}
        // goBack={true}
        navlink={true}
      />
    );
  };

  const renderProducts = (): JSX.Element | null => {
    if (list.length > 0) {
      return (
        <div
          style={{
            marginBottom: 30,
            // borderBottom: `1px solid ${theme.colors.mainColor}`,
          }}
        >
          {list?.map((item, index, array) => {
            const isLast = index === array.length - 1;
            return <items.OrderItem key={index} item={item} isLast={isLast} />;
          })}
        </div>
      );
    }

    return null;
  };

  const renderAppliedText = (): JSX.Element | null => {
    if (discount > 0) {
      return (
        <div style={{ marginBottom: 30, padding: '0 20px' }}>
          <svg.PromocodeAppliedSvg />
        </div>
      );
    }

    return null;
  };

  const renderApplyPromocode = (): JSX.Element | null => {
    if (discount > 0) return null;

    return (
      <div
        style={{
          marginBottom: 60,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0 20px',
        }}
      >
        {/* <custom.InputField
          label='Enter the voucher'
          containerStyle={{width: 'calc(70% - 5px)'}}
          placeholder={'Enter the promocode'}
        /> */}
        {/* <components.Button
          title='Apply'
          containerStyle={{padding: 0, width: 'calc(30% - 5px)'}}
          // onClick={() => {
          //   dispatch(actions.setDiscount(20));
          // }}
        /> */}
      </div>
    );
  };

  const renderTotal = (): JSX.Element | null => {
    if (list.length > 0) {
      return (
        <div
          style={{
            padding: 20,
            borderRadius: 15,
            backgroundColor: theme.colors.pastelMint,
            margin: '0px 20px 20px 20px',
          }}
        >
          {/* <div style={{ ...utils.rowCenterSpcBtween(), marginBottom: 10 }}>
            <text.H4 style={{ color: theme.colors.mainColor }}>
              Total Weight
            </text.H4>
            <text.T16 style={{ color: theme.colors.mainColor }}>
              {totalWeight} kg
            </text.T16>
          </div> */}
          <div style={{ ...utils.rowCenterSpcBtween(), marginBottom: 10 }}>
            <text.H5 style={{ color: theme.colors.mainColor }}>Subtotal</text.H5>
            <text.T16 style={{ color: theme.colors.mainColor }}>
              ETB&nbsp; {formatMoney(subtotal)}
            </text.T16>
          </div>

          {discount > 0 && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 10,
              }}
            >
              <h5
                style={{
                  margin: 0,
                  ...theme.fonts.Inter_600SemiBold,
                  fontSize: 16,
                  color: theme.colors.textColor,
                  lineHeight: 1.5,
                }}
              >
                Discount
              </h5>
              <span
                style={{
                  margin: 0,
                  ...theme.fonts.Inter_600SemiBold,
                  fontSize: 16,
                  color: theme.colors.textColor,
                  lineHeight: 1.5,
                }}
              >
                - {discountAmount}
              </span>
            </div>
          )}
          {/* <div
            style={{
              marginBottom: 10,

              paddingBottom: 10,
              ...utils.rowCenterSpcBtween(),
            }}
          >
            <text.T14 style={{ color: theme.colors.textColor }}>
              Estimated Shipping Cost
            </text.T14>
            <text.T14 style={{ color: theme.colors.textColor }}>
              ETB&nbsp; {(totalWeight * 15).toFixed(2)}
            </text.T14>
          </div> */}
          <div
            style={{
              marginBottom: 20,
              borderRadius: 12,
              boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
            }}
          >
            {/* <label
              htmlFor='delivery-method'
              style={{
                display: 'block',
                marginTop: 10,
                color: theme.colors.mainColor,
                fontSize: 14,
                ...theme.fonts.Inter_600SemiBold,
              }}
            >
              Select Delivery Method
            </label> */}
            <InputLabel
              id='deliver_methods'
              style={{ color: theme.colors.mainColor, marginBottom: '5px' }}
            >
              Select Delivery Method
            </InputLabel>
            <Select
              labelId='deliver_methods'
              id='demo-simple-select'
              value={deliveryMethod}
              label='Age'
              onChange={(e) => setDeliveryMethod(e.target.value)}
              style={{
                width: '100%',
                height: '40px',
              }}
            >
              <MenuItem value='pickup_from_shop'>Pickup from Shop</MenuItem>
              <MenuItem value='deliver_to_desk'>Deliver to Desk</MenuItem>
            </Select>
            {/* <select
              id='delivery-method'
              value={deliveryMethod}
              onChange={(e) => setDeliveryMethod(e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                fontSize: 14,
                borderRadius: 8,
                border: 0,
                color: theme.colors.mainColor,
                appearance: 'none',
                // backgroundColor: theme.colors.mainColor,
                marginTop: 6,
              }}
            >
              <option value='pickup_from_shop'>Pickup from Shop</option>
              <option value='deliver_to_desk'>Deliver to Desk</option>
            </select> */}
          </div>
          <div style={{ ...utils.rowCenterSpcBtween() }}>
            <text.H4 style={{ color: theme.colors.mainColor }}>Total</text.H4>
            <text.H4 style={{ color: theme.colors.mainColor }}>
              ETB&nbsp; {formatMoney(total)}
            </text.H4>
          </div>

          <div style={{ marginTop: '25px' }}>{renderButton()}</div>
        </div>
      );
    }

    return null;
  };

  const renderButton = (): JSX.Element | null => {
    const handleCreateOrder = async () => {
      if (!isSignedIn) {
        // Redirect to the sign-in page if not signed in
        navigate('/SignIn', { state: { from: location.pathname } });
      } else {
        setIsExploding(false);
        setIsLoading(true);

        const orderData = {
          products: list.map((item) => ({
            id: item.id,
            quantity: item.quantity ?? 1,
            is_pack: item.default_sales_type === 'PACK',
          })),
          delivery_method: deliveryMethod,
        };

        try {
          const response = await createOrder(orderData);
          if (response.success) {
            setMessage(response.data.message);
            setIsExploding(true);
            setOrderId(response.data.order.id);
            handleOrderSuccess();
            dispatch(actions.resetCart());
          }
        } catch (error) {
          console.error('Failed to create order:', error);
          toast.error('Failed to create order. Please try again.');
        } finally {
          // Ensure loading state is set to false in both success and failure cases
          setIsLoading(false);
        }
      }
    };

    return (
      <>
        {loading ? (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <CircularProgress color='inherit' size={24} />
            <div style={{ marginTop: '10px', fontWeight: 'bold' }}>
              Processing checkout...
            </div>
          </div>
        ) : (
          <components.Button
            style={{
              color: 'black',
              backgroundColor: '#EEFF07',
            }}
            title='Proceed to Checkout'
            colorScheme='light'
            onClick={handleCreateOrder}
            containerStyle={{ padding: '0 20px' }}
          />
        )}
      </>
    );
  };

  const renderContent = (): JSX.Element | null => {
    return (
      // <main
      //   className='container'
      //   style={{
      //     paddingTop: 20,
      //     paddingBottom: 84, // 64 + 20
      //     marginTop: 160,
      //     width: '100vw', // Full viewport width
      //     maxWidth: '100%', // Prevent container constraints
      //     overflowX: 'hidden',
      //   }}
      // >
      //   <div style={{

      //     overflowY: 'auto',
      //     display: 'flex',
      //     gap: '16px', // Optional spacing between children
      //     alignItems: 'flex-start', // Align children to the top
      //   }}>
      //     <div>
      //       <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
      //         {renderProducts()}
      //         {renderAppliedText()}
      //       </div>
      //     </div>

      //     {renderTotal()}
      //   </div>
      //   {/* {renderButton()} */}
      // </main>
      <main
        className='container'
        style={{
          paddingTop: 20,
          paddingBottom: 84,
          marginTop: 200,
          width: '100vw',
          maxWidth: '1440px',
          overflowX: 'hidden',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: '16px',
            alignItems: 'flex-start',
          }}
        >
          <div
            style={{
              flex: '1 1 100%',
              maxWidth: '100%',
            }}
          >
            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
              {renderProducts()}
              {renderAppliedText()}
            </div>
          </div>

          <div
            style={{
              // flex: '1 1 550px',
              flex: isMobile ? '1 1 100%' : '1 1 550px',
              width: '100%',
            }}
          >
            {renderTotal()}
          </div>
        </div>
      </main>
    );
  };

  const renderEmptyContent = (): JSX.Element => {
    return (
      <main
        className='container '
        style={{
          padding: '0px 20px 94px 20px',
          marginTop: 52,
          paddingTop: '18vh',
        }}
      >
        <div
          style={{
            marginTop: 52,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <img
            src={require('../../assets/icons/18.png')}
            alt='order successful'
            style={{
              width: 123.39,
              marginBottom: 4,
            }}
          />
          <text.H2
            style={{
              marginBottom: 14,
              textTransform: 'capitalize',
              color: theme.colors.mainColor,
            }}
          >
            Your Cart is empty!
          </text.H2>
          <text.T16
            style={{
              whiteSpace: 'pre-line',
              color: theme.colors.textColor,
              marginBottom: 30,
            }}
          >
            Looks like you haven't chosen the{'\n'}items you like.
          </text.T16>
        </div>
        <components.Button
          style={{
            color: '#fff',
          }}
          title='Browse products'
          colorScheme='light'
          onClick={() => {
            dispatch(actions.resetFilters());
            navigate('/Home');
          }}
          containerStyle={{ marginBottom: 10 }}
        />
      </main>
    );
  };

  const renderBottomTabBar = (): JSX.Element | null => {
    return <components.BottomTabBar />;
  };
  const renderFooter = (): JSX.Element => {
    return (
      <components.Footer
        logo={true}
        copyright={true}
        links={[
          { label: 'Home', path: '/Home' },
          { label: 'About', path: '/About' },
          { label: 'Services', path: '/Services' },
          { label: 'Contact', path: '/Contact' },
        ]}
      />
    );
  };

  return (
    <>
      {renderHeader()}
      <OrderSuccessModal
        open={open}
        onClose={handleClose}
        message={message}
        orderId={orderId ?? 0}
      />
      {list.length > 0 ? renderContent() : renderEmptyContent()}
      <div style={{ width: '100%' }}>{renderFooter()}</div>

      {/* {renderBottomTabBar()} */}
      <FloatingWhatsAppButton />
    </>
  );
};
